import React, { useContext, useEffect } from 'react'
import { DemoContext } from '../lib/DemoProvider'
import Button from '@react/react-spectrum/Button'
import { 
    getAperitifToken,
    getAperitifStorage,
    getPutUrl,
    logAlert,
    uploadAssetFile,
    runAperitifOperation,
    getFilenameWithoutExt,
    STATUS_CODE_FAIL_FORBIDDEN,
    STATUS_CODE_FAIL_UNAUTHORIZED,
    logMsg
} from '../lib/lib'
import analytics from '../config/analytics'

export default function Cutout () {
    const { selectedFiles, aperitif, utStorage, customFiles, outputUpdate, refineFiles, dispatch, page } = useContext(DemoContext)
    
    useEffect(() => {

    }, [])

    function runCutout() {
        try {
            analytics.sendEventName('click', `${page}:runcutout`)
            const startDate = new Date()
            // let fileList = null
            dispatch({ type: 'set-wait', payload: {wait: true} })
            dispatch({ type: 'set-apiStatus', payload: {apiStatus: "Uploading..."} })
            for (var i = 0; i < selectedFiles.length; i++) {
                var fileReader = new FileReader()
                const selectedFile = selectedFiles[i]
                fileReader.onloadend = async (e) => {
                    try {
                        let tempOutputs //TODO
                        if (!aperitif) {
                            const getAperitifTokenResult = await getAperitifToken()
                            if (getAperitifTokenResult.error) {
                                const errMsg = (getAperitifTokenResult.response && getAperitifTokenResult.response.status ? `${getAperitifTokenResult.response.status}: ${getAperitifTokenResult.response.statusText}` : getAperitifTokenResult.e && getAperitifTokenResult.e.message) || 'Unknown'
                                logAlert(null, errMsg)
                                postUpload(null, null, null, startDate)
                                return
                            }
                            const { outputs } = await getAperitifTokenResult.response.json();
                            const getAperitifStorageResult = await getAperitifStorage(3, outputs)
                            if (getAperitifStorageResult.error) {
                                const errMsg = (getAperitifStorageResult.response && getAperitifStorageResult.response.status ? `${getAperitifStorageResult.response.status}: ${getAperitifStorageResult.response.statusText}` : getAperitifStorageResult.e && getAperitifStorageResult.e.message) || 'Unknown'
                                logAlert(null, errMsg)
                                postUpload(null, null, null, startDate)
                                return
                            }
                            const getAperitifStorageResponse = await getAperitifStorageResult.response.json();
                            if (getAperitifStorageResult.response.status === STATUS_CODE_FAIL_FORBIDDEN || getAperitifStorageResult.response.status === STATUS_CODE_FAIL_UNAUTHORIZED || !outputs) {
                                // clickElement('btnShowTempOutputsError')
                                return
                            } else {
                                tempOutputs = getAperitifStorageResponse.outputs
                                tempOutputs.userToken = outputs.userToken
                                dispatch({ type: 'set-aperitif', payload: {aperitif: tempOutputs} })
                            }
                        }
                        dispatch({ type: 'set-uploadProgress', payload: {uploadProgress: 0} })

                        let assetNum = 0 //input image file
                        const putUrlResponse = await getPutUrl(aperitif || utStorage || tempOutputs, assetNum)
                        if (putUrlResponse.error) {
                            logAlert(null, putUrlResponse.msg)
                            postUpload(null, null, null, startDate)
                            return
                        }
                        const uploadedFile = {
                            tempUrls: putUrlResponse.url,
                            name: selectedFile.name,
                            storage: 'external',
                            shortName: getFilenameWithoutExt(selectedFile.name),
                            type: selectedFile.name.split('.').pop(),
                            size: selectedFile.size,
                            url: selectedFile.url || putUrlResponse.url,
                            thumbnail: URL.createObjectURL([...selectedFiles].filter( f => f.name === selectedFile.name)[0])
                            // assetType: assetType
                        }
                        const formData = new FormData()
                        formData.append('file', selectedFile)
                        const opts = {
                            config: {
                                timeout: 30000,
                                onUploadProgress: (e) => {
                                    const currentProgress = (parseInt(e.loaded) / parseInt(e.total) * 100).toFixed(0)
                                    dispatch({ type: 'set-uploadProgress', payload: {uploadProgress: currentProgress} })
                                    if (currentProgress === "100") {
                                        dispatch({ type: 'upload', payload: false })
                                    }
                                }
                            },
                            data: selectedFile
                        }
                        await uploadAssetFile(putUrlResponse.url.put, opts, (response, err) => {
                            if (response) {
                                postUpload(response, customFiles, uploadedFile, startDate)
                                selectedFiles.find( x => x.name === selectedFile.name)['aperitif'] = tempOutputs
                                // console.log(`selectedFiles: ${selectedFiles}`)
                                // console.log(`selectedFile: ${selectedFile}`)
                                // runApi( (selectedFile, res) => {
                                runApi(selectedFile, res => {
                                    const endDate = new Date()
                                    var seconds = Math.round((endDate.getTime() - startDate.getTime()) / 1000)
                                    logMsg(null, `seconds:${seconds}`)
                                    dispatch({ type: 'set-wait', payload: {wait: false} })
                                })
                            } else {
                                postUpload(null, null, uploadedFile, startDate)
                                logAlert(null, err)
                            }
                        })
                    } catch(e) {
                        postUpload(null, null, null, startDate)
                        logAlert(e)
                    }
                }
                fileReader.readAsArrayBuffer(selectedFile);
            }
        } catch (e) {
            logAlert(e)
        }
    }

    async function runApi(selectedFile, cb) {
        try {
            analytics.sendEventName('click', `${page}:removebackground`)
            logMsg(null, 'running API...')
            dispatch({ type: 'set-apiStatus', payload: {apiStatus: "Running Remove Background API..."} })
            const bodyObject = {
                input: {
                    href: selectedFile.aperitif.urls[0].get,
                    storage: 'external'
                },
                output: {
                    href: selectedFile.aperitif.urls[1].put,
                    storage: 'external',
                    type: 'image/png',
                    mask: {
                        "format": "soft"
                    }
                }
            }
            const res = await runAperitifOperation(selectedFile.aperitif.userToken, bodyObject)
            if (!res.error) {
                analytics.sendEventName('api', `${page}:runAperitifOperation:succeeded`)
                if (res.job.status === 'succeeded') {
                    logMsg(null, `succeeded`)
                    const newRefineFiles = refineFiles
                    newRefineFiles.push(selectedFile)
                    dispatch({ type: 'set-refineFiles', payload: {refineFiles: newRefineFiles} })
                } else {
                    logMsg(null, res.job.jobId)
                    cb({
                        error: true,
                        msg: `${res.job.status.toUpperCase()}`,
                        job: res.job.jobID || null
                    })
                }
            } else {
                analytics.sendEventName('api', `${page}:runAperitifOperation:error`)
                cb({
                    error: true,
                    msg: "Something went wrong. ",
                    job: res.job.jobID || null
                })
            }
            cb({
                error: false,
                msg: "",
                job: null
            })
            // dispatch({ type: 'set-wait', payload: {wait: false} })
        } catch(e) {
            analytics.sendEventName('api', `${page}:runAperitifOperation:error`)
            cb({
                error: true,
                msg: "Something went wrong. ",
                job: null
            })
            // dispatch({ type: 'set-wait', payload: {wait: false} })
        }
    }

    function postUpload(response, customFiles, uploadedFile, startDate) {
        try {
            let newCustomFiles = []
            if (customFiles) {
                newCustomFiles = JSON.parse(JSON.stringify(customFiles))
                newCustomFiles.push(uploadedFile)
            } else {
                dispatch({ type: 'set-aperitif', payload: { aperitif: null } }) //error case
                dispatch({ type: 'set-utStorage', payload: { utStorage: null } }) //error case
            }
            dispatch({ type: 'set-customFiles', payload: { customFiles: newCustomFiles } })
            if (!response) {
                dispatch({ type: 'set-wait', payload: {wait: false} })
            }
            dispatch({ type: 'upload', payload: false })
            dispatch({ type: 'set-outputUpdate', payload: {outputUpdate: !outputUpdate} })
    
            const endDate = new Date()
            var seconds = Math.round((endDate.getTime() - startDate.getTime()) / 1000)
            logMsg(null, `upload:seconds:${seconds}`)
        } catch(e) {
            logAlert(e)
        }
    }

    return <div className="adobe-app">
        <div className='btn-right'>
            <Button variant="cta" disabled={selectedFiles&&selectedFiles.length===0} onClick={e => runCutout(e)}>Remove Background</Button>
        </div>
    </div>
}
